import React, { ChangeEvent, useCallback } from 'react'
import { Box, Switch } from '@mui/material'
import { useListFilters } from 'shared/api/list'

export function SwitchFilter({
  label,
  filterKey,
}: {
  label: string
  filterKey: string
}) {
  const {
    filters: { [filterKey]: value },
    setFilter,
  } = useListFilters()
  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setFilter(filterKey, e.target.checked)
    },
    [filterKey, setFilter],
  )
  return (
    <Box>
      <Switch onChange={onChange} value={value} />
      {label}
    </Box>
  )
}
